export const publishSlider = [
  '',
  `mutation publishSlider($id:Int!) {
        publishSlider(id:$id)
    }
  `,
  'publishSlider'];
